import getApiBaseUrl from './baseUrl';

const loginConfig = (accessToken) => {
  const tenantHost =
    typeof window !== 'undefined' && window.location
      ? window.location.host
      : null;
  const config = {
    method: 'post',
    url: `${getApiBaseUrl()}auth/ms-login`,
    headers: {
      'Content-Type': 'application/json',
      ...(tenantHost ? { 'x-tenant-host': tenantHost } : {}),
    },
    data: {
      idToken: accessToken,
    },
  };
  return config;
};

export default loginConfig;
